import React from 'react';
import { toastr } from 'react-redux-toastr';

import iconUpload from '../../../../assets/images/icon_upload.svg';
import avatarImage from '../../../../assets/images/bot_avatar.png';

const Avatar = ({ url, onChange }) => {
  const isValidAvatar = async (file) => {
    if (!file) return false;

    const MAX_AVATAR_SIZE = 1024 * 1024 * 5; // 5 MB

    if (file.size > MAX_AVATAR_SIZE) {
      toastr.error('Ops', 'Por favor, a imagem deve ter no máximo 5 MB.');
      return false;
    }

    const img = new Image();
    const imageUrl = URL.createObjectURL(file);
    img.src = imageUrl;
    await img.decode();

    const { width, height } = img;
    if (width !== 300 || height !== 300) {
      toastr.error('Ops', 'Por favor, a imagem deve ter 300x300');
      return false;
    }

    return true;
  };

  const handleChangeAvatar = async (event) => {
    const file = event.target.files[0];

    if (await isValidAvatar(file)) {
      onChange(file);
    }
  };

  return (
    <div>
      <label className="label">Foto / logo do bot</label>

      <div className="submenu__settings__avatar-container">
        <div className="submenu__settings__avatar-wrapper">
          <label htmlFor="avatar-bot">
            <img
              src={url || avatarImage}
              alt="Bot icon"
              className="submenu__settings__avatar-image"
            />
            <input
              id="avatar-bot"
              type="file"
              accept=".png,.jpg,.jpeg"
              onChange={handleChangeAvatar}
            />
            <div className="submenu__settings__avatar-hover">
              <img src={iconUpload} alt="icon" />
              <span>alterar foto</span>
            </div>
          </label>
        </div>
        <span>
          Clique no ícone para fazer upload de uma nova foto ou logo, sua imagem
          deve estar em formato .JPG, .JPEG, ou .PNG, ter 300x300 pixels e no
          máximo 5mb
        </span>
      </div>
    </div>
  );
};

export default Avatar;
